var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExportsSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23,28c0,0.5517578-0.4482422,1-1,1H4c-0.5517578,0-1-0.4482422-1-1V4c0-0.5517578,0.4482422-1,1-1h18 c0.5517578,0,1,0.4482422,1,1v2h2V4c0-1.6542969-1.3457031-3-3-3H4C2.3457031,1,1,2.3457031,1,4v24c0,1.6542969,1.3457031,3,3,3h18 c1.6542969,0,3-1.3457031,3-3v-2h-2V28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8203125,13.1162109c-0.1484375-0.125-0.3564453-0.1494141-0.5322266-0.0693359 C24.1123047,13.1298828,24,13.3056641,24,13.5V15h-4v2h4v1.5c0,0.1943359,0.1123047,0.3701172,0.2880859,0.453125 C24.3554688,18.984375,24.4277344,19,24.5,19c0.1152344,0,0.2285156-0.0390625,0.3203125-0.1162109l3-2.5 C27.9345703,16.2890625,28,16.1484375,28,16s-0.0654297-0.2890625-0.1796875-0.3837891L24.8203125,13.1162109z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,8c-4.4111328,0-8,3.5888672-8,8s3.5888672,8,8,8s8-3.5888672,8-8S28.4111328,8,24,8z M24,22 c-3.3085938,0-6-2.6914062-6-6s2.6914062-6,6-6s6,2.6914062,6,6S27.3085938,22,24,22z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportsSmall);
export default __webpack_public_path__ + "static/media/exports--small.a1b4b168909d2aa8cf569b4231bb47dd.svg";
export { ForwardRef as ReactComponent };